/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".km-type[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  cursor: pointer; }\n\n.km-content[_ngcontent-%COMP%] {\n  border-radius: 1rem;\n  background-color: #79C4DB;\n  color: black !important; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customer-profile/customer-profile.component.scss.shim.ngstyle.js.pre-build-optimizer.js